import { render, staticRenderFns } from "./ProfilePet.vue?vue&type=template&id=b879fa82&scoped=true&"
import script from "./ProfilePet.vue?vue&type=script&lang=js&"
export * from "./ProfilePet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b879fa82",
  null
  
)

export default component.exports